const HARD_REDIRECT_ROUTES = new Set(["/share-video", "/home", "/batch-scan"]);

export function redirectToRoute(navigate, route, options) {
  if (HARD_REDIRECT_ROUTES.has(route)) {
    window.location.href = route;
    return;
  }

  navigate(route, options);
}
